import { render, staticRenderFns } from "./tab4.vue?vue&type=template&id=3cd2634e&scoped=true"
import script from "./tab4.vue?vue&type=script&lang=js"
export * from "./tab4.vue?vue&type=script&lang=js"
import style0 from "./tab4.vue?vue&type=style&index=0&id=3cd2634e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd2634e",
  null
  
)

export default component.exports